import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Verify required Firebase config exists
const verifyFirebaseConfig = () => {
  const requiredFields = ['apiKey', 'authDomain', 'projectId', 'appId'];
  const missingFields = requiredFields.filter(field => !firebaseConfig[field]);

  if (missingFields.length > 0) {
    console.warn(`Firebase config missing fields: ${missingFields.join(', ')}`);
  }

  // Log current project connection (dev only)
  if (import.meta.env?.DEV) {
    console.info(`Firebase project: ${firebaseConfig.projectId || 'unset'}`);
  }
};

// Verify config before initializing
verifyFirebaseConfig();

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
// Export db as an alias to firestore for backward compatibility
export const db = firestore;
export const storage = getStorage(app);

// Check emulator setting, but don't throw errors
const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
if (useEmulators) {
  // Connect to emulators if explicitly enabled
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  if (import.meta.env?.DEV) {
    console.info('Firebase emulators enabled');
  }
}

// Log Firebase initialization status (dev only)
if (import.meta.env?.DEV) {
  console.info(`Firebase initialized (projectId=${firebaseConfig.projectId || 'unset'})`);
}

// Export the app instance
export default app;
